module.exports = __webpack_public_path__ + "static/media/SF-1-if-wrong.09407451.mp3";